import React from 'react';
import { Layout, Menu, Avatar, Dropdown, Typography, Button } from 'antd';
import { 
  DashboardOutlined, 
  DatabaseOutlined, 
  KeyOutlined,
  UserOutlined,
  TeamOutlined,
  LogoutOutlined 
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { authApi } from '../api';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    authApi.logout();
    logout();
  };

  // 菜单项
  const menuItems = [
    ...(user?.role === 'admin' ? [{
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表板',
    }] : []),
    {
      key: '/contents',
      icon: <DatabaseOutlined />,
      label: '内容查看',
    },
    {
      key: '/keywords',
      icon: <KeyOutlined />,
      label: '关键词管理',
    },
    ...(user?.role === 'admin' ? [{
      key: '/users',
      icon: <TeamOutlined />,
      label: '用户管理',
    }] : []),
  ];

  // 用户下拉菜单
  const userMenuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        theme="dark"
        width={200}
        style={{
          position: 'fixed',
          height: '100vh',
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div style={{ 
          height: 64, 
          margin: 16, 
          display: 'flex', 
          alignItems: 'center' 
        }}>
          <Title level={4} style={{ color: 'white', margin: 0 }}>
            监控系统
          </Title>
        </div>
        
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>

      <Layout style={{ marginLeft: 200 }}>
        <Header 
          style={{ 
            background: '#fff', 
            padding: '0 24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 1px 4px rgba(0,21,41,.08)',
          }}
        >
          <div />
          
          <Dropdown 
            menu={{ items: userMenuItems }}
            placement="bottomRight"
          >
            <Button 
              type="text" 
              style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 8 
              }}
            >
              <Avatar size="small" icon={<UserOutlined />} />
              <span>{user?.username}</span>
            </Button>
          </Dropdown>
        </Header>

        <Content
          style={{
            margin: '24px',
            padding: '24px',
            background: '#fff',
            borderRadius: '6px',
            minHeight: 'calc(100vh - 112px)',
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout; 